import { render, staticRenderFns } from "./DialogCreateRole.vue?vue&type=template&id=a591bba6&scoped=true&"
import script from "./DialogCreateRole.vue?vue&type=script&lang=js&"
export * from "./DialogCreateRole.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateRole.vue?vue&type=style&index=0&id=a591bba6&lang=scss&scoped=true&"
import style1 from "./DialogCreateRole.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a591bba6",
  null
  
)

export default component.exports